export const actionRequiredNotificationComponentOptions: ng.IComponentOptions = {
  templateUrl: "../ServiceDesk/sdDirectives/action-required-notification.html",
  transclude: true,
  bindings: {
    items: "=",
    close: "&onClose"
  }
};
